module.exports = __webpack_public_path__ + "img/illu_upload_newmedia_0.b7842939.png";